module.exports = __webpack_public_path__ + "img/IoTServe4.e45ce43b.png";